import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { videoCardBadgeStyles } from "@/components/common/video-card/service";
import {
  getVideoLength,
  isBeforeWeekAgo,
} from "@/components/common/video-card/components/service";

export const PlaylistTreatedAsVideoPreset = ({
  data,
}: {
  data: PlaylistTreatedAsVideoPreviewVM;
}) => {
  const { duration, publishedAt, currentTime } = data;

  return (
    <>
      <Badge
        className={cn(
          videoCardBadgeStyles,
          "right-3 bottom-3 bg-black text-white",
        )}
      >
        {getVideoLength(duration ?? 0)}
      </Badge>
      <>
        {publishedAt && !isBeforeWeekAgo(publishedAt) && (
          <Badge
            className={cn(
              videoCardBadgeStyles,
              "bg-remedium-blue top-3 left-3 text-white",
            )}
          >
            NOWOŚĆ
          </Badge>
        )}
      </>
      {currentTime != null && currentTime > 0 && (
        <div
          className={"absolute bottom-0 left-0 z-1 h-1 bg-red-500"}
          style={{
            width: `${(currentTime / (duration as number)) * 100}%`,
          }}
        ></div>
      )}
    </>
  );
};
